import { Box, Typography } from '@branch-messenger/willow-ui'
import { FC, ReactNode } from 'react'

export type AccountDetailTitleProps = {
  children: ReactNode
}

export const AccountDetailTitle: FC<AccountDetailTitleProps> = ({
  children,
}) => {
  return (
    <Box $display="flex" $align="center">
      <Typography $bold>{children}</Typography>
    </Box>
  )
}
